import { GoalFilterDocument } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';

export const useUpdateProjectsOverviewFilterDocument = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (filterDocument: Partial<GoalFilterDocument>) =>
      updateSettings({
        filters: {
          projectsOverview: filterDocument,
        },
      }),
    [updateSettings],
  );
};
